import { call, put, takeEvery, select } from 'redux-saga/effects';
import { daUtil } from "../../../api";
import {
  DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD,
  DISPATCH_DRIVER_DEPOSIT_DRIVER_LOADED,
  DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD,
  DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOADED,
  DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD,
  DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOADED,
  DISPATCH_DRIVER_DEPOSIT_MAKE_RETURN,
  DISPATCH_DRIVER_DEPOSIT_ORDER_MAKE_RETURN,
  DISPATCH_DRIVER_DEPOSIT_CANCEL_RETURNED,
  DISPATCH_DRIVER_DEPOSIT_CANCEL_RECEIVED,
  DISPATCH_DRIVER_DEPOSIT_CANCEL_INVOICED,
  DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE,
  DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE_PRODUCT,
  DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE_ORDER,
  DISPATCH_DRIVER_DEPOSIT_UNLOCK,
} from "../actions/deposit_driver";
import Notifications from "react-notification-system-redux";
import {stateToCenterId} from "../../../utils/center";

function notifError(e) {
  const errorMessage = e.response && e.response.data.detail ? e.response.data.detail : e.message;
  return Notifications.error({title: "Une erreur est survenue" , "message": errorMessage,  autoDismiss:5, dismissible:"click"});
}


function* onLoadDepositDriver(action) {
  try {
    let offset = 0;
    if (typeof(action.offset) !== 'undefined') {
      offset = action.offset;
    }
    const res = yield call(daUtil.get, `/depositdriver/history/?driver_id=${action.driver_id}&offset=${offset}`);
    yield put({...res, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOADED});
  } catch(e) {
    yield put(notifError(e));
  }
}
function* onDriverDepositMakeReturn(action) {
  const state = yield select();

  try {
    let datas = {
      'driver_id': action.driver_id,
      'center_id': stateToCenterId(state),
      'returns': [
        action.product_id ? { product_id: action.product_id, quantity: action.quantity } : { deposit_label: action.deposit_label, quantity: action.quantity }
      ]
    };
    yield call(daUtil.post, '/depositdriver/return_deposit_bulk/', datas);
    yield put(Notifications.success({title: "Consigne Livreur" , "message": "Retour de produit effectué!",  autoDismiss:3, dismissible:"click"}));
  } catch(error) {
    yield put(notifError(error));
  }
  yield put({...action, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
}

function* onDriverDepositOrderMakeReturn(action) {
  try {
    yield call(daUtil.post, '/depositdriver/return_order_to/', action);
    yield put(Notifications.success({title: "Consigne Livreur" , "message": "Retour de commande effectué!",  autoDismiss:3, dismissible:"click"}));
  } catch(error) {
    yield put(notifError(error));
  }
  yield put({...action, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
}

function* onDriverDepositCancelReturned(action) {
  const state = yield select();
  try {
    let datas = {
      'deposit_driver_id': action.deposit_driver_id,
      'center_id': stateToCenterId(state),
    };
    yield call(daUtil.post, '/depositdriver/cancel_returned/', datas);
    yield put(Notifications.success({title: "Consigne Livreur" , "message": "Correction effectuée!",  autoDismiss:3, dismissible:"click"}));
  } catch(error) {
    yield put(notifError(error));
  }
  yield put({...action, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
}
function* onDriverDepositCancelReceived(action) {
  const state = yield select();
  try {
    let datas = {
      'deposit_driver_id': action.deposit_driver_id,
      'deposit_user_id': action.deposit_user_id,
      'center_id': stateToCenterId(state),
    };
    yield call(daUtil.post, '/depositdriver/cancel_received/', datas);
    yield put(Notifications.success({title: "Consigne Livreur" , "message": "Correction effectuée!",  autoDismiss:3, dismissible:"click"}));
  } catch(error) {
    yield put(notifError(error));
  }
  yield put({...action, type: action.trigger_action_type});
}

function* onDriverDepositCancelInvoiced(action) {
  const state = yield select();
  try {
    let datas = {
      'deposit_driver_id': action.deposit_driver_id,
      'center_id': stateToCenterId(state),
    };
    yield call(daUtil.post, '/depositdriver/cancel_invoiced/', datas);
    yield put(Notifications.success({title: "Consigne Livreur" , "message": "Annulation de facturation effectuée!",  autoDismiss:3, dismissible:"click"}));
  } catch(error) {
    yield put(notifError(error));
  }
  yield put({...action, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
}

function* onLoadDepositDrivers(action) {
  try {
    const res = yield call(daUtil.get, `/depositdriver/by_driver/`);
    yield put({...res, type: DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOADED});
  } catch(e) {
    yield put(notifError(e));
  }
}
function* onLoadDepositProductsDetail(action) {
  try {
    const res = yield call(daUtil.get, `/depositdriver/by_product/`);
    yield put({...res, type: DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOADED});
  } catch(e) {
    yield put(notifError(e));
  }
}

function* onDriverDepositInstantInvoice(action) {
  const state = yield select();

  try {
    const datas = {
      'driver_id': action.driver_id,
      'center_id': action.center_id || stateToCenterId(state),
      // Pas d'`invoices` => facturer toutes les dettes
    };
    yield call(daUtil.post, '/depositdriver/invoice_deposit_bulk/', datas);
    yield put(Notifications.success({
      title: "Facturation instantanée",
      message: "Consignes facturées avec succès",
      autoDismiss: 3,
      dismissible: "click"
    }));

    // Recharger les données du livreur
    yield put({driver_id: action.driver_id, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
    yield put({type: DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD});
    yield put({type: DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD});
  } catch(error) {
    yield put(notifError(error));
  }
}

function* onDriverDepositInstantInvoiceProduct(action) {
  const state = yield select();

  try {
    const datas = {
      'driver_id': action.driver_id,
      'center_id': action.center_id || stateToCenterId(state),
      'invoices': [{
        'product_id': action.product_id || null,
        'deposit_label': action.deposit_label || null,
        'quantity': action.quantity,
        'reason': action.reason || "",
      }],
    };
    yield call(daUtil.post, '/depositdriver/invoice_deposit_bulk/', datas);
    yield put(Notifications.success({
      title: "Facturation produit",
      message: `Produit facturé avec succès (${action.quantity} unité${action.quantity > 1 ? 's' : ''})`,
      autoDismiss: 3,
      dismissible: "click"
    }));

    // Recharger les données du livreur
    yield put({driver_id: action.driver_id, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
    yield put({type: DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD});
    yield put({type: DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD});
  } catch(error) {
    yield put(notifError(error));
  }
}

function* onDriverDepositInstantInvoiceOrder(action) {
  const state = yield select();

  try {
    const datas = {
      'driver_id': action.driver_id,
      'center_id': action.center_id || stateToCenterId(state),
      'order_id': action.order_id,
      'reason': action.reason || "",
    };
    yield call(daUtil.post, '/depositdriver/instant_invoice_order/', datas);
    yield put(Notifications.success({
      title: "Facturation commande",
      message: "Commande facturée avec succès",
      autoDismiss: 3,
      dismissible: "click"
    }));

    // Recharger les données du livreur
    yield put({driver_id: action.driver_id, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
    yield put({type: DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD});
    yield put({type: DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD});
  } catch(error) {
    yield put(notifError(error));
  }
}

function* onDriverDepositUnlock(action) {
  const state = yield select();

  try {
    const datas = {
      'driver_id': action.driver_id,
      'center_id': action.center_id || stateToCenterId(state),
      'reason': action.reason || "",
    };

    // Ajouter les paramètres optionnels pour déblocage granulaire
    if (action.deposit_label) {
      datas.deposit_label = action.deposit_label;
      datas.quantity = action.quantity;
    }
    if (action.order_id) {
      datas.order_id = action.order_id;
    }

    const response = yield call(daUtil.post, '/depositdriver/unlock_driver/', datas);

    // Message adapté selon le type d'exemption
    let message = response.message || "Livreur débloqué jusqu'à 2h du matin";

    yield put(Notifications.success({
      title: "Déblocage livreur",
      message: message,
      autoDismiss: 3,
      dismissible: "click"
    }));

    // Recharger les données du livreur
    yield put({driver_id: action.driver_id, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
    yield put({type: DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD});
  } catch(error) {
    yield put(notifError(error));
  }
}

export const depositDriverSagas = [
  takeEvery(DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD, onLoadDepositDriver),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD, onLoadDepositDrivers),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD, onLoadDepositProductsDetail),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_MAKE_RETURN, onDriverDepositMakeReturn),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_ORDER_MAKE_RETURN, onDriverDepositOrderMakeReturn),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_CANCEL_RETURNED, onDriverDepositCancelReturned),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_CANCEL_RECEIVED, onDriverDepositCancelReceived),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_CANCEL_INVOICED, onDriverDepositCancelInvoiced),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE, onDriverDepositInstantInvoice),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE_PRODUCT, onDriverDepositInstantInvoiceProduct),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE_ORDER, onDriverDepositInstantInvoiceOrder),
  takeEvery(DISPATCH_DRIVER_DEPOSIT_UNLOCK, onDriverDepositUnlock),
];
